import { EventType, PublicClientApplication } from "@azure/msal-browser";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { msalConfig, setToken } from './api/azure/authConfig';
import App from './App';
import './index.css';
import store from "./redux/store/reduxStore";
import reportWebVitals from './reportWebVitals';

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  // Default to using the first account if no account is active on page load
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    const successKeys = [EventType.LOGIN_SUCCESS, EventType.ACQUIRE_TOKEN_SUCCESS]
    if (successKeys.includes(event.eventType) && event?.payload?.account) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
      setToken(event.payload)
    }
  });

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App pca={msalInstance} />
      </Provider>
    </React.StrictMode>
  );
  reportWebVitals();
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
